import React, { useLayoutEffect, useState, useRef } from "react";
import Modal from "../adminReproduction/modal";
import StatusChoiceModal from "../adminReproduction/statusChoiceModal";
import DiagnosticModal from "../adminReproduction/DiagnosticModal";
import { updateReproduction } from "../../../api/reproductionApi";
import { deleteAnimal } from "../../../api/animalsApi";
import swal from "sweetalert";
import '../adminReproduction/ReproWheel.css'
import repro from '../../../cow.jpg';

const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

const CYCLE_MONTHS = 24;
const CYCLE_DAYS = CYCLE_MONTHS * 30;

const statusColors = {
    "croissance": "#113dffff",
    "Peut faire la saillie": "#f1c40f",
    "Repos": "#27ae60",
};

const arabStatus = [
    "النمو",
    "يمكن التلقيح",
    "الراحة"
]

const ringRadius = 500;
const circumference = 2 * Math.PI * ringRadius;

const segments = [
    {
        label: "Repos",
        color: "#27ae60",
        value: 60.5 / 365
    }, {
        label: "Croissance",
        color: "#11a0ffff",
        value: 17.8 / 365
    },
    {
        label: "Croissance",
        color: "#0f1ef1ff",
        value: 12.5 / 365
    },
    {
        label: "Croissance",
        color: "#11a0ffff",
        value: 91.5 / 365
    },
    {
        label: "Croissance",
        color: "#0746f3f0",
        value: 61 / 365
    },
    {
        label: "Saillie",
        color: "#fcff4bf0",
        value: 45 / 365
    },
    {
        label: "Repos",
        color: "#27ae60",
        value: 80 / 365
    },
];

function daysBetween(from, to) {
    return Math.floor((to - from) / (1000 * 60 * 60 * 24));
}

function getMonthAngle(dateString) {
    const d = new Date(dateString);
    const month = d.getMonth();
    const day = d.getDate();
    const dayOfYear = (month * 30) + day;
    return dayOfYear * 0.5;
}

function getDaysInMonth(year, month) {
    return new Date(year, month + 1, 0).getDate();
}


export default function CroissanceWheel({ reproductions, onStatusChange }) {
    const radius = 450;
    const center = 510;
    const today = new Date();
    const todayDateString = today.toISOString().split('T')[0];
    const todayAngle = getMonthAngle(todayDateString);
    const rotationAngle = 180.7 - todayAngle;

    const [selected, setSelected] = useState(null);
    const [showChoiceModal, setShowChoiceModal] = useState(false);
    const [showDiagnostic, setShowDiagnostic] = useState(false);

    const [zoom, setZoom] = useState(1);
    const [pan, setPan] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);
    const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

    const containerRef = useRef(null);
    const svgRef = useRef(null);

    const countLittleAnimals = (reproductions, today) => {
        let count = 0;
        reproductions.forEach((r) => {
            const dateN = new Date(r.animal.date_naissance);
            if (isNaN(dateN)) return;
            const daysOld = (today - dateN) / (1000 * 60 * 60 * 24);
            if (daysOld < 720 && (!r.date_saille && !r.date_gestation && !r.date_velage)) count += 1;
        });
        return count;
    };


    const handleMouseDown = (e) => {
        if (e.button === 0) {
            setIsDragging(true);
            setDragStart({
                x: e.clientX - pan.x,
                y: e.clientY - pan.y
            });
        }
    };

    const handleWheel = (e) => {
        if (!e.ctrlKey) return;
        e.preventDefault();

        if (!containerRef.current) return;

        const rect = containerRef.current.getBoundingClientRect();
        const mouseX = e.clientX - rect.left;
        const mouseY = e.clientY - rect.top;

        const delta = e.deltaY * -0.001;
        const newZoom = Math.min(Math.max(0.5, zoom + delta), 2);

        const zoomPoint = {
            x: (mouseX - pan.x) / zoom,
            y: (mouseY - pan.y) / zoom
        };

        const newPan = {
            x: mouseX - zoomPoint.x * newZoom,
            y: mouseY - zoomPoint.y * newZoom
        };

        setZoom(newZoom);
        setPan(newPan);
    };

    const handleMouseMove = (e) => {
        if (isDragging) {
            let newX = e.clientX - dragStart.x;
            let newY = e.clientY - dragStart.y;
            setPan({ x: newX, y: newY });
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    function openPopup(repro) {
        setSelected(repro);
    }

    function closePopup() {
        setSelected(null);
    }

    function handleChangeStatus(repro) {
        setSelected(repro);
        setShowChoiceModal(true);
    }

    async function handleDelete(id) {
        swal({
            title: "Etes vous sûr?",
            icon: "info",
            buttons: true,
        }).then(async (good) => {
            if (good) {
                try {
                    await deleteAnimal(id);
                    swal('Animal a été vendu avec succés', "Animal supprimé!", { icon: "success" });
                } catch (e) { console.error(e); swal("Error: N'est pas vendu !"); }
            } else {
                swal("N'est pas vendu !");
            }
        });
    }

    function onSelectNext(next) {
        if (!selected || !selected.id) {
            return;
        }
        setShowChoiceModal(false);

        if (next === "Diagnostic") {
            setShowDiagnostic(true);
            return;
        }

        const statusToSend = next === "Supprimer événement" ? "previous" : next;

        onStatusChange(selected.id, statusToSend)
            .then(() => {
                setShowChoiceModal(false);
                setSelected(null);
            })
            .catch(err => {
                console.error("change status failed:", err.response?.data || err.message || err);
                setShowChoiceModal(false);
            });
    }

    function onDiagnosticResult(result) {
        const id = selected?.id;
        setShowDiagnostic(false);
        setSelected(null);
        const saillieDate = new Date(selected.date_saille);
        const prevuVelgeCalcul = new Date(saillieDate.getTime() + (283 * 24 * 60 * 60 * 1000));
        const formattedDate = prevuVelgeCalcul.toISOString().slice(0, 19).replace('T', ' ');

        console.log(saillieDate);
        console.log(prevuVelgeCalcul);

        if (result === "positif") {
            onStatusChange(id, "Gestation");
            updateReproduction(id, { date_gestation: selected.date_saille, date_prevu_velage: formattedDate })
        } else {
            onStatusChange(id, "Velage");
        }
    }

    const btnStyle = {
        padding: "10px 15px",
        marginLeft: "20px",
        background: "#3498db",
        border: "none",
        borderRadius: "5px",
        color: "white",
        cursor: "pointer",
        textDecoration: "none",
    };

    return (
        <>

            <Modal show={!!selected} onClose={closePopup}>
                {selected && (() => {
                    const today = new Date();
                    const birthDate = new Date(selected.animal.date_naissance);
                    const isValidDate = !isNaN(birthDate.getTime());
                    const ageInDays = isValidDate ? Math.floor((today - birthDate) / (1000 * 60 * 60 * 24)) : null;
                    const canChangeStatus = ageInDays >= 365 && selected?.animal?.genre === "femelle";
                    const Sold = selected?.animal?.genre === "male";
                    return (
                        <div>
                            <h2>Animal Details</h2>
                            <p><strong>Numero :</strong> {selected.animal.numero}</p>
                            <p><strong>Nom:</strong> {selected.animal.nom}</p>
                            <p><strong>Genre:</strong> {selected.animal.genre}</p>
                            <p><strong>Date Naissance:</strong> {selected.animal.date_naissance}</p>
                            {ageInDays !== null && <p><strong>Age:</strong> {ageInDays} jours</p>}
                            <div style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
                                <a href={`/admin/animal/details/${selected.animal.id}`} style={btnStyle}>Details</a>
                                <a href={`/admin/edit/${selected.animal.id}`} style={btnStyle}>Modifier</a>
                                {canChangeStatus && (<button type="button" onClick={() => { handleChangeStatus(selected); }} style={btnStyle} >
                                    Changer Status
                                </button>
                                )}
                                {Sold && (
                                    <button type="button" onClick={() => { handleDelete(selected.animal.id); }} style={btnStyle}>
                                        Vente
                                    </button>
                                )}

                            </div>
                        </div>
                    );
                })()}
            </Modal>

            <StatusChoiceModal
                show={showChoiceModal}
                currentStatus={selected?.status?.titre}
                onSelect={onSelectNext}
                onClose={() => setShowChoiceModal(false)}
            />

            <DiagnosticModal
                show={showDiagnostic}
                onResult={onDiagnosticResult}
                onClose={() => setShowDiagnostic(false)}
            />


            <strong className="todayDate">
                <label>date :</label> {todayDateString} <br />
                <label> Nombre des Reproductions En Croissance :</label>  {countLittleAnimals(reproductions, today)} / {reproductions.length}
            </strong>
            <div
                style={{ cursor: isDragging ? "grabbing" : "grab" }}
                onWheel={handleWheel}
                onMouseMove={handleMouseMove}
                onMouseDown={handleMouseDown}
                onMouseUp={handleMouseUp}
                onMouseLeave={handleMouseUp}
            >
                <div
                    style={{
                        width: "100%",
                        height: "110%",
                        borderRadius: "8px",
                        background: "#fff",
                        overflow: "hidden",
                    }}>
                    <svg
                        ref={svgRef}
                        viewBox="-200 -100 1513 1300"
                        preserveAspectRatio="xMidYMid meet"
                        className="repro-wheel-svg"
                        style={{
                            marginTop: '30px',
                            maxHeight: '800px',
                            transform: `translate(${pan.x}px) `,
                            transformOrigin: "center center",
                            transition: isDragging ? "none" : "transform 0.1s ease-out"
                        }}
                    >


                        {(() => {
                            let dashOffset = 0;
                            const todayStartAngle = 30.3;
                            const todayStartAngleRec = 30;

                            return (
                                <g>
                                    <g transform={`rotate(${todayStartAngle}, ${center}, ${center})`}>{segments.map((seg, i) => {
                                        const dash = seg.value * circumference;
                                        const element = (
                                            <circle
                                                key={i}
                                                cx={center}
                                                cy={center}
                                                r={ringRadius}
                                                fill="none"
                                                stroke={seg.color}
                                                strokeWidth="22"
                                                strokeLinecap="butt"
                                                strokeDasharray={`${dash} ${circumference}`}
                                                strokeDashoffset={-dashOffset}
                                            />
                                        );
                                        dashOffset += dash;
                                        return element;
                                    })}</g>
                                    <g transform={`rotate(${todayStartAngleRec}, ${center}, ${center})`}>

                                        {(() => {
                                            const labeledIndices = [0, 3, 6, 9, 12, 15, 16, 18, 21, 24, 27, 30, 33, 36, 39, 42, 45, 48, 51, 54, 57, 60, 63, 66, 69];
                                            const labeled = ['20 mois', '21 mois', '22 mois', '23 mois', '', '1 mois', '35 jours', '2 mois', '3 mois ', '4 mois', '5 mois', '6 mois', '7 mois', '8 mois', '9 mois', '10 mois', '11 mois', '12 mois', '13 mois', '14 mois', '15 mois', '16 mois', '17 mois', '18 mois', '19 mois'];
                                            return Array.from({ length: 72 }, (_, i) => {
                                                const angle = i * 5;
                                                let x = center + ringRadius * Math.cos(angle * Math.PI / 180);
                                                let y = center + ringRadius * Math.sin(angle * Math.PI / 180);
                                                const elements = [
                                                    <rect
                                                        key={i}
                                                        x={x - 10}
                                                        y={y - 2.5}
                                                        width="20"
                                                        height="3"
                                                        fill="black"
                                                        transform={`rotate(${angle}, ${x}, ${y})`}
                                                    />
                                                ];
                                                if (labeledIndices.includes(i)) {
                                                    const textRadius = ringRadius + 90;
                                                    let LineRadius = ringRadius + 60;
                                                    let textX = center + textRadius * Math.cos(angle * Math.PI / 180);
                                                    let textY = center + textRadius * Math.sin(angle * Math.PI / 180);
                                                    let lineX = center + LineRadius * Math.cos(angle * Math.PI / 180);
                                                    let lineY = center + LineRadius * Math.sin(angle * Math.PI / 180);

                                                    const labelIndex = labeledIndices.indexOf(i);
                                                    if (labelIndex === 6) {
                                                        LineRadius = ringRadius + 40;
                                                        lineX = center + LineRadius * Math.cos(angle * Math.PI / 180);
                                                        lineY = center + LineRadius * Math.sin(angle * Math.PI / 180);
                                                        textX = center - 15 + textRadius * Math.cos(angle * Math.PI / 180);
                                                        textY = center - 25 + textRadius * Math.sin(angle * Math.PI / 180);
                                                        y = center + 5 + ringRadius * Math.sin(angle * Math.PI / 180);
                                                        x = center + 25 + ringRadius * Math.cos(angle * Math.PI / 180);
                                                    }
                                                    if (labelIndex === 4) {
                                                        LineRadius = ringRadius + 30;
                                                        lineX = center + LineRadius * Math.cos(angle * Math.PI / 180);
                                                        lineY = center + LineRadius * Math.sin(angle * Math.PI / 180);
                                                        y = center + ringRadius * Math.sin(angle * Math.PI / 180);
                                                        x = center + ringRadius * Math.cos(angle * Math.PI / 180);
                                                    }
                                                    elements.push(<>
                                                        {labelIndex === 4 && <line x1={lineX + 12} y1={lineY - 6.5} x2={x + 1} y2={lineY + 9} stroke="#640303ff" strokeWidth="2" />}
                                                        <line x1={lineX} y1={lineY} x2={x} y2={y} stroke={labelIndex === 2 ? "#640303ff" : '#000000ff'} strokeWidth={labelIndex === 2 ? "#fc0404ff" : '#000000ff'} />
                                                        <text
                                                            key={`text-${i}`}
                                                            x={textX}
                                                            y={textY}
                                                            fontSize="15"
                                                            textAnchor="middle"
                                                            alignmentBaseline="middle"
                                                            fill="black"
                                                            transform={`rotate(${-todayStartAngleRec}, ${textX}, ${textY})`}
                                                        >
                                                            {labeled[labelIndex].split('\n').map((line, i) => (
                                                                <tspan x={textX} dy={i === 0 ? 0 : 12}>{line}</tspan>
                                                            ))}
                                                        </text></>
                                                    );
                                                }
                                                return elements;
                                            });
                                        })()}
                                    </g>
                                </g>
                            );
                        })()}

                        <circle
                            cx={center}
                            cy={center}
                            r={radius}
                            fill="white"
                            stroke="#333"
                            strokeWidth="3"
                        />

                        {(() => {
                            const angle = 90;
                            const x = center + (radius - 40) * Math.cos(angle * Math.PI / 180);
                            const y = center + (radius - 40) * Math.sin(angle * Math.PI / 180);

                            return (
                                <g>
                                    <line x1={x} y1={y + 40} x2={center} y2={center} stroke="#ff0000ff" />
                                    <line x1={x} y1={y + 40} x2={center} y2={center} stroke="#ff0000ff" />
                                    <text x={x} y={y + 140} fontSize="20" textAnchor="middle" fill="red">
                                        Aujourd'hui
                                    </text>
                                </g>
                            );
                        })()}

                        <g transform={`rotate(${rotationAngle}, ${center}, ${center})`}>
                            {Array.from({ length: 24 }, (_, i) => {
                                const m = monthNames[i % 12];
                                const angle = i * (360 / 24) - 90;

                                const x = center + radius * Math.cos(angle * Math.PI / 180);
                                const y = center + radius * Math.sin(angle * Math.PI / 180);
                                const textX = center + (radius + 20) * Math.cos(angle * Math.PI / 180);
                                const textY = center + (radius + 20) * Math.sin(angle * Math.PI / 180);

                                return (
                                    <g key={i}>
                                        <line x1={center} y1={center} x2={x} y2={y} stroke="#bbb" strokeWidth="1" />
                                        <text
                                            x={textX}
                                            y={textY}
                                            fontSize="12"
                                            textAnchor="middle"
                                            alignmentBaseline="middle"
                                            transform={`rotate(${-rotationAngle}, ${textX}, ${textY})`}
                                        >
                                            {m}
                                        </text>
                                    </g>
                                );
                            })}

                            {monthNames.map((m, i) => {
                                const year = today.getFullYear();
                                const daysInMonth = getDaysInMonth(year, i);
                                const monthStartAngle = i * 15 - 90;
                                const dayAngleStep = 15 / daysInMonth;

                                return Array.from({ length: Math.floor(daysInMonth / 5) }, (_, j) => {
                                    const day = (j + 1) * 5;
                                    const angle = monthStartAngle + ((day - 1) * dayAngleStep);
                                    const x1 = center + (radius - 60) * Math.cos(angle * Math.PI / 180);
                                    const y1 = center + (radius - 60) * Math.sin(angle * Math.PI / 180);
                                    const x2 = center + (radius - 80) * Math.cos(angle * Math.PI / 180);
                                    const y2 = center + (radius - 80) * Math.sin(angle * Math.PI / 180);
                                    const textX = center + (radius - 90) * Math.cos(angle * Math.PI / 180);
                                    const textY = center + (radius - 90) * Math.sin(angle * Math.PI / 180);

                                    return (
                                        <g key={`${i}-${day}`}>
                                            <line x1={x1} y1={y1} x2={x2} y2={y2} stroke="#ccc" strokeWidth="1" />
                                            <text
                                                x={textX}
                                                y={textY}
                                                fontSize="8"
                                                textAnchor="middle"
                                                alignmentBaseline="middle"
                                                fill="#666"
                                                transform={`rotate(${-rotationAngle}, ${textX}, ${textY})`}
                                            >
                                                {day}
                                            </text>
                                        </g>
                                    );
                                });
                            })}
                            {monthNames.map((m, i) => {
                                const year = today.getFullYear();
                                const daysInMonth = getDaysInMonth(year, i);
                                const monthStartAngle = i * 15 + 90;
                                const dayAngleStep = 15 / daysInMonth;

                                return Array.from({ length: Math.floor(daysInMonth / 5) }, (_, j) => {
                                    const day = (j + 1) * 5;
                                    const angle = monthStartAngle + ((day - 1) * dayAngleStep);
                                    const x1 = center + (radius - 60) * Math.cos(angle * Math.PI / 180);
                                    const y1 = center + (radius - 60) * Math.sin(angle * Math.PI / 180);
                                    const x2 = center + (radius - 80) * Math.cos(angle * Math.PI / 180);
                                    const y2 = center + (radius - 80) * Math.sin(angle * Math.PI / 180);
                                    const textX = center + (radius - 90) * Math.cos(angle * Math.PI / 180);
                                    const textY = center + (radius - 90) * Math.sin(angle * Math.PI / 180);

                                    return (
                                        <g key={`${i}-${day}`}>
                                            <line x1={x1} y1={y1} x2={x2} y2={y2} stroke="#ccc" strokeWidth="1" />
                                            <text
                                                x={textX}
                                                y={textY}
                                                fontSize="8"
                                                textAnchor="middle"
                                                alignmentBaseline="middle"
                                                fill="#666"
                                                transform={`rotate(${-rotationAngle}, ${textX}, ${textY})`}
                                            >
                                                {day}
                                            </text>
                                        </g>
                                    );
                                });
                            })}

                            {(() => {
                                const animalsByAngle = new Map();

                                reproductions.forEach((r, index) => {
                                    if (!r?.animal || !r?.status) return;

                                    const dateN = new Date(r.animal.date_naissance);
                                    const dateNDiff = (today - dateN) / (1000 * 60 * 60 * 24);

                                    if (dateNDiff > 720 || (r.date_saille || r.date_gestation || r.date_velage || r.date_avortement)) return;

                                    const birthDate = new Date(r.animal.date_naissance);
                                    if (isNaN(birthDate.getTime())) return;
                                    const ageDays = daysBetween(birthDate, today);
                                    if (ageDays > CYCLE_DAYS) return;
                                    if (r.date_saille || r.date_gestation || r.date_velage) return;

                                    const cycleStart = birthDate;
                                    const diffDays = Math.max(0, daysBetween(cycleStart, today));
                                    const cycleDay = diffDays % CYCLE_DAYS;
                                    const angle = (cycleDay / CYCLE_DAYS) * 360 + todayAngle - 91;

                                    const status = "Croissance";

                                    const GROUPING_THRESHOLD = 4;
                                    const angleKey = Math.round(10 / GROUPING_THRESHOLD) * GROUPING_THRESHOLD;

                                    if (!animalsByAngle.has(angleKey)) {
                                        animalsByAngle.set(angleKey, []);
                                    }

                                    animalsByAngle.get(angleKey).push({
                                        reproduction: r,
                                        angle: angle,
                                        status: status,
                                        index: index
                                    });
                                });

                                const elements = [];

                                animalsByAngle.forEach((animals, angleKey) => {
                                    const count = animals.length;

                                    animals.forEach((animal, posIndex) => {
                                        const { reproduction: r, angle, status, index } = animal;

                                        let radiusOffset = 0;
                                        if (count > 0) {
                                            const spacing = 45;
                                            radiusOffset = ((posIndex - (count) / 2) * spacing);
                                        }

                                        const adjustedRadius = radius - 40 + radiusOffset;
                                        const x = center + adjustedRadius * Math.cos(angle * Math.PI / 180);
                                        const y = center + adjustedRadius * Math.sin(angle * Math.PI / 180);
                                        const dateNa = new Date(r.animal.date_naissance);
                                        const dateNDiffa = (today - dateNa) / (1000 * 60 * 60 * 24);

                                        let colorTr = null;
                                        if (dateNDiffa < 365) {
                                            colorTr = statusColors['croissance'];
                                        }
                                        if (dateNDiffa > 365 && dateNDiffa < 455) {
                                            colorTr = statusColors['Peut faire la saillie'];
                                        }
                                        if (dateNDiffa > 455 && dateNDiffa < 730) {
                                            colorTr = statusColors['Repos'];
                                        }

                                        const triangleSize = 30;
                                        const triangleAngle = 230;

                                        const p1x = x + triangleSize * Math.cos(-120 * Math.PI / 180);
                                        const p1y = y + triangleSize * Math.sin(-40 * Math.PI / 180);
                                        const p2x = x + triangleSize * Math.cos(30 * Math.PI / 180);
                                        const p2y = y + triangleSize * Math.sin(-10 * Math.PI / 180);
                                        const p3x = x + triangleSize * Math.cos(100 * Math.PI / 180);
                                        const p3y = y + triangleSize * Math.sin(120 * Math.PI / 180);
                                        const trianglePoints = `${p1x},${p1y} ${p2x},${p2y} ${p3x},${p3y}`;

                                        elements.push(
                                            <g key={index} onClick={() => openPopup(r)} style={{ cursor: "pointer" }}>
                                                <polygon
                                                    points={trianglePoints}
                                                    fill={colorTr}
                                                    stroke="#000"
                                                    strokeWidth="2"
                                                />
                                                <text
                                                    x={x}
                                                    y={y + 5}
                                                    fontSize="12"
                                                    fontWeight="bold"
                                                    textAnchor="middle"
                                                    fill="white"
                                                    transform={`rotate(${-rotationAngle}, ${x}, ${y})`}
                                                >
                                                    {r.animal?.numero}
                                                </text>
                                            </g>
                                        );
                                    });
                                });

                                return elements;
                            })()}
                        </g>

                        <defs>
                            <clipPath id="circleClip">
                                <circle cx={center} cy={center} r="50" />
                            </clipPath>
                        </defs>

                        <image
                            href={repro}
                            x={center - 80}
                            y={center - 50}
                            width="160"
                            clipPath="url(#circleClip)"
                            preserveAspectRatio="xMidYMid slice"
                        />
                    </svg>
                </div>

                <div className="key-reproduction-div" style={{
                    marginTop: "20px",
                    textAlign: "left",
                    fontSize: "calc(12px + 0.5vw)",
                    justifyContent: "flex-start",
                    gap: "10px",
                    width: "100%"
                }}>
                    {Object.entries(statusColors).map(([label, color], index) => (
                        <div key={label} style={{ display: "flex", alignItems: "center", marginBottom: "6px" }}>
                            <span style={{
                                width: "calc(20px + 1vw)",
                                height: "calc(20px + 1vw)",
                                backgroundColor: color,
                                borderRadius: "3px",
                                marginRight: "8px",
                                flexShrink: 0,
                            }}></span>
                            <span style={{ fontSize: "calc(10px + 0.5vw)" }}>{label} - {arabStatus[index]}</span>
                        </div>
                    ))}
                </div>
            </div >

        </>

    );
}